const VIEWS = {
  MENU: { key: "MENU", title: "Event Settings", subTitle: "Manage event settings." },
  IMPERSONATE: { key: "IMPERSONATE", title: "Impersonate User", subTitle: "Login as a parent or member of staff." },
  ACCESS: { key: "ACCESS", title: "Event Access", subTitle: "Specify who can access this event." },
  DELETE: { key: "DELETE", title: "Delete Event", subTitle: "Delete this event and all associated data." },
  SETTINGS: { key: "SETTINGS", title: "Event Settings", subTitle: "General event settings." },
  BASIC_INFO: { key: "BASIC_INFO", title: "Event Basic Info", subTitle: "Specify an event name and description." },
  MEETING_TYPES: { key: "MEETING_TYPES", title: "Meeting Types", subTitle: "Add meeting types for this event." },
  SESSIONS: { key: "SESSIONS", title: "Update Sessions", subTitle: "Add / Edit or remove a sessions." },
  META: { key: "META", title: "Meta Details", subTitle: "View event meta details." },
};

export { VIEWS }
